import { render, staticRenderFns } from "./CampaniaDialog.vue?vue&type=template&id=0104278c&scoped=true"
import script from "./CampaniaDialog.vue?vue&type=script&lang=js"
export * from "./CampaniaDialog.vue?vue&type=script&lang=js"
import style0 from "./CampaniaDialog.vue?vue&type=style&index=0&id=0104278c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104278c",
  null
  
)

export default component.exports